import { Classes } from "@blueprintjs/core";
import nameInitials from "name-initials";

import { LazyImg } from "@/components/helpers/ui/LazyImg";
import { Box } from "@/components/layout/flexbox";

interface AvatarWithPrettyNullProps {
  user?: {
    photo?: string | null;
    name?: string | null;
    email?: string | null;
  };
  size?: number;
  loading?: boolean;
  defaultText?: string | null;
  height?: number | null;
}

export function AvatarWithPrettyNull({
  user,
  size = 32,
  loading = false,
  defaultText = null,
  height = null,
}: AvatarWithPrettyNullProps) {
  if (loading) {
    return (
      <Box
        width={size}
        height={size}
        style={{
          borderRadius: "100%",
        }}
        className={Classes.SKELETON}
      />
    );
  }
  return (
    <div>
      {user?.photo ? (
        <LazyImg
          className="bg-blue-200"
          style={{
            borderRadius: "100%",
          }}
          width={size}
          height={height ? height : size}
          src={user?.photo}
        />
      ) : (
        <EmptyBox
          size={size}
          text={defaultText || nameInitials(user?.name || user?.email || "")}
        />
      )}
    </div>
  );
}

const EmptyBox = (props: { size: number; text: string }) => {
  const innerCircleSize = props.size * 0.8;
  return (
    <div
      className="grid place-items-center bg-blue-100 rounded-[50%]"
      style={{
        width: props.size,
        height: props.size,
      }}
    >
      <div
        className="grid place-items-center font-bold bg-white rounded-[50%]"
        style={{
          width: innerCircleSize,
          height: innerCircleSize,
          fontSize: props.size / 5,
        }}
      >
        {props.text}
      </div>
    </div>
  );
};
